export interface AnalyticsConfig {
  writeKey: string;
  environment: string;
}

export class Analytics {
  public static identify(userId: string, properties?: object): void {
    if (this.isAnalyticsInitialised()) {
      window.analytics.identify(userId, properties);
    }
  }

  public static track(event: string, properties?: object): void {
    if (this.isAnalyticsInitialised()) {
      // If addblock is present will block acquiring traits which will cause errors
      // Need to force traits to be passed down from Segment to Mixpanel
      const traits =
        !!window.analytics.user && !!window.analytics.user().traits
          ? { traits: window.analytics.user().traits() }
          : undefined;
      window.analytics.track(event, properties, traits);
    }
  }

  public static group(groupId: string, properties?: object): void {
    if (this.isAnalyticsInitialised()) {
      window.analytics.group(groupId, properties);
    }
  }

  public static init(config: AnalyticsConfig): void {
    if (config.writeKey) {
      const analytics = (window.analytics = window.analytics || []);
      if (!analytics.initialize) {
        if (analytics.invoked) {
          if (window.console && console.error) console.error('Segment snippet included twice.');
        } else {
          analytics.invoked = !0;
          analytics.methods = [
            'trackSubmit',
            'trackClick',
            'trackLink',
            'trackForm',
            'pageview',
            'identify',
            'reset',
            'group',
            'track',
            'ready',
            'alias',
            'debug',
            'page',
            'once',
            'off',
            'on',
            'addSourceMiddleware',
            'addIntegrationMiddleware',
            'setAnonymousId',
            'addDestinationMiddleware',
          ];
          analytics.factory = function (e) {
            return function (...args) {
              const t = Array.prototype.slice.call(args);
              t.unshift(e);
              analytics.push(t);
              return analytics;
            };
          };
          for (let e = 0; e < analytics.methods.length; e++) {
            const key = analytics.methods[e];
            analytics[key] = analytics.factory(key);
          }
          analytics.load = (key, e) => {
            const t = document.createElement('script');
            t.type = 'text/javascript';
            t.async = !0;
            t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
            const n: any = document.getElementsByTagName('script')[0];
            n.parentNode.insertBefore(t, n);
            analytics._loadOptions = e;
          };
          analytics._writeKey = config.writeKey;
          analytics.SNIPPET_VERSION = '4.13.2';
          analytics.load(config.writeKey);
          analytics.page();
        }
      }
    }
  }

  private static isAnalyticsInitialised() {
    return !!window.analytics;
  }
}

export default Analytics;
